module.exports = "/lucky-balls/img/bigball/BigBall_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_013.png
// module id = 908
// module chunks = 0